<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'GENERAL.DOCUMENTS_LABEL' | translate }}</h3>
    </div>
  </div>

  <div *ngIf="qinetic_position?.qinetic_attachments?.length">
    <ol class="sp-padding__left-x4 sp-margin__top-x2">
      <li
        *ngFor="let attachment of qinetic_position?.qinetic_attachments"
        class="sp-margin__bottom">
        {{ attachment }}
      </li>
    </ol>
  </div>

  <div
    *ngIf="!qinetic_position?.qinetic_attachments?.length && !is_read_running"
    class="sp-width__full sp-margin__top-x12 sp-padding__x4">
    <div class="sp-margin__bottom sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
    <p class="sp-text__center sp-color__primary">{{ 'ORDER_DETAILS.DOCS_NOT_FOUND_LABEL' | translate }}</p>
    <div class="sp-margin__top sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
  </div>
</div>
